import { useCallback } from 'react';
import { Action } from 'redux';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { probeGetConnectionTree, probeGetInitialDBTree, probeGetSample } from 'js/actions';

type ProbeAdapter = {
  getProbeSample: (id: number, stage: any, payload: any) => Promise<any>;
  requestConnectionTree: (credentialId: number, isRoot: boolean, folder: any) => void;
  requestInitialDbTree: (credentialId: number, isRoot: boolean, info: any) => void;
};

export default function useProbeAdapter(): ProbeAdapter {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();

  const requestConnectionTree: ProbeAdapter['requestConnectionTree'] = useCallback(
    (credentialId, isRoot, folder) => {
      dispatch(probeGetConnectionTree(credentialId, isRoot, folder));
    },
    [],
  );

  const requestInitialDbTree: ProbeAdapter['requestInitialDbTree'] = useCallback(
    (credentialId, isRoot, info) => {
      if (credentialId && info) {
        dispatch(probeGetInitialDBTree(credentialId, isRoot, info));
      }
    },
    [],
  );

  const getProbeSample: ProbeAdapter['getProbeSample'] = useCallback((id, stage, payload) => {
    return dispatch(probeGetSample(id, stage, payload));
  }, []);

  return {
    requestConnectionTree,
    requestInitialDbTree,
    getProbeSample,
  };
}
